export const EDITOR_BI_SOURCE = 38;
export const EDITOR_BI_ENDPOINT = 'editor';
export const EDITOR_BI_ERROR_ENDPOINT = 'trg';
